import React from 'react';
import AdvisorDormitory from '../advisor/AdvisorDormitory';

export default function IslamicAdvisorDormitory() {
  return <AdvisorDormitory islamic />;
}